<template>
	<div>
		<div>
			<headbar title="全部老师" index="1"></headbar>
		</div>
		<div class="main">
			<div
				class="teacher_item"
				v-for="(item, i) in teacherList"
				:key="i"
				@click="goAppTeacher(item.id)"
			>
				<div class="item_left">
					<img :src="item.img_small_arr.mp" class="teacher_img" />
				</div>
				<div class="item_right">
					<div class="name">{{ item.name }}</div>
					<div class="desc">{{ item.desc }}</div>
				</div>
			</div>
		</div>
	</div>
</template>
<script>
import headbar from '../../components/headbar.vue'
export default {
	data() {
		return {
			teacherList: [],
		}
	},
	created() {
		this.getTeacherList()
	},
	methods: {
		async getTeacherList() {
			let res = await this.$axios.get('teacher/getTeacherList')
			console.log(res)
			if (res.code == 10000 || res.code == 10001) {
				this.teacherList = res.data
			}
		},
		goAppTeacher(id) {
			let nowDevice = localStorage.getItem('device')
			if (nowDevice == 'ios') {
				window.webkit.messageHandlers.jsToOcWithPrams.postMessage({
					jump_type: 2,
					jump_url: id,
				})
			} else if (nowDevice == 'android' || nowDevice == 'ard' || nowDevice === "pad") {
				window.android.jsCallAndroidArgs(
					`{jump_type: 2, jump_url: ${id}}`
				)
			}
		},
	},
	components: {
		headbar,
	},
}
</script>
<style lang="scss" scoped>
.main {
	padding: 15px;
	.teacher_item {
		display: flex;
		padding-top: 12.5px;
		padding-bottom: 12px;
		border-bottom: 1px solid #f6f7f9;
		.item_left {
			width: 107px;
			height: 135px;
			.teacher_img {
				width: 100%;
				height: 100%;
			}
		}
		.item_right {
			padding: 9.5px 0;
			width: 228px;
			height: 77.5px;
			margin-left: 9.5px;
			.name {
				font-size: 14px;
				font-weight: 400;
				margin-bottom: 14px;
			}
			.desc {
				font-size: 11px;
				color: #626466;
				overflow: hidden;
				text-overflow: ellipsis;
				display: -webkit-box;
				-webkit-box-orient: vertical;
				-webkit-line-clamp: 5;
			}
		}
	}
}
</style>
